/* eslint-disable */
import React, { Fragment, Dispatch, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import DeleteDialog from '../../common/components/deleteDialog';
import clsx from 'clsx';
import Toolbar from '@material-ui/core/Toolbar';
import { postRequestQuote } from "../../store/actions/wem.actions";
import _, { get } from "lodash";
import FullscreenLoader from "./../../common/components/FullscreenLoader";
import { useHistory, useLocation } from "react-router-dom";
import { getFiltersData, getWemList } from "../../store/actions/wem.actions";

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    backgroundColor: '#FFFFFF',
  },
  dialogHeader: {
    padding: '20px 24px',
    borderBottom: '1px solid #E8E8E8',
    position: 'relative',
  },
  dialogTitle: {
    fontSize: '1.5rem',
    fontWeight: 700,
    fontFamily: 'Nunito',
    color: '#000000',
    margin: 0,
  },
  closeIconButton: {
    position: 'absolute',
    right: 8,
    top: 12,
    padding: 8,
    color: '#666666',
  },
  formContainer: {
    padding: '24px 24px 16px 24px',
  },
  inputRow: {
    display: 'flex',
    gap: '16px',
    marginBottom: '20px',
  },
  textField: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: '24px',
      fontFamily: 'Nunito',
      fontSize: '0.875rem',
      backgroundColor: '#FFFFFF',
      '& fieldset': {
        borderColor: '#D5D5D5',
      },
      '&:hover fieldset': {
        borderColor: '#999999',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1A9FE0',
        borderWidth: 1,
      },
      '&.Mui-error fieldset': {
        borderColor: '#f44336',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 16px',
      fontFamily: 'Nunito',
      fontSize: '0.875rem',
      color: '#333333',
    },
    '& .MuiInputLabel-root': {
      fontFamily: 'Nunito',
      fontSize: '0.875rem',
      color: '#999999',
      '&.Mui-focused': {
        color: '#1A9FE0',
      },
      '&.Mui-error': {
        color: '#f44336',
      },
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
    '& .MuiFormHelperText-root': {
      fontFamily: 'Nunito',
      fontSize: '0.75rem',
      marginLeft: '14px',
      marginTop: '4px',
    },
  },
  cartSection: {
    padding: '0 24px 24px 24px',
  },
  cartTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    fontFamily: 'Nunito',
    color: '#000000',
    marginBottom: '12px',
  },
  tableWrapper: {
    border: '1px solid #E8E8E8',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  table: {
    '& .MuiTableCell-root': {
      borderBottom: '1px solid #F0F0F0',
      padding: '12px 16px',
    },
  },
  tableHead: {
    backgroundColor: '#F8F8F8',
    '& .MuiTableCell-head': {
      fontFamily: 'Nunito',
      fontSize: '0.813rem',
      fontWeight: 700,
      color: '#003D6D',
      borderBottom: '1px solid #E0E0E0',
      padding: '14px 16px',
    },
  },
  tableCell: {
    fontFamily: 'Nunito',
    fontSize: '0.813rem',
    color: '#666666',
    fontWeight: 400,
  },
  qtyContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
  },
  qtyButton: {
    width: '24px',
    height: '24px',
    minWidth: '24px',
    padding: 0,
    border: '1px solid #D5D5D5',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    color: '#666666',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      borderColor: '#999999',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
  },
  qtyText: {
    fontFamily: 'Nunito',
    fontSize: '0.875rem',
    fontWeight: 600,
    color: '#333333',
    minWidth: '45px',
    textAlign: 'center',
  },
  deleteButton: {
    padding: 6,
    color: '#1A9FE0',
    '&:hover': {
      backgroundColor: 'rgba(26, 159, 224, 0.08)',
    },
  },
  dialogFooter: {
    padding: '16px 24px',
    borderTop: '1px solid #E8E8E8',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
  },
  submitButton: {
    backgroundColor: '#1A9FE0',
    width: 140,
    fontWeight: 700,
    textTransform: 'capitalize',
    fontFamily: 'Nunito',
    fontSize: '0.875rem',
    color: '#FFFFFF',
    borderRadius: '24px',
    height: 40,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#1585BD',
      boxShadow: 'none',
    },
  },
  cancelButton: {
    backgroundColor: '#E8E8E8',
    width: 140,
    fontWeight: 700,
    textTransform: 'capitalize',
    fontFamily: 'Nunito',
    fontSize: '0.875rem',
    color: '#666666',
    borderRadius: '24px',
    height: 40,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#D5D5D5',
      boxShadow: 'none',
    },
  },
  addUpdateDailogTitle: {
    position: "absolute",
    top: 10,
    left: 10
  },

  title: {
    flex: '1 1 100%',
  },
}));

const initialUser = {
  firstName: 'Shabbash',
  lastName: 'Khan',
  mobile: '+971 50809040',
  email: 'Shabbash.Khan@gmail.com',
};

const initialCart = [
  { id: 1, partNo: 'AEF-2P-4.0LH', details: 'Lift, 2-Post 3Ph Low Profile, Overall Height 3.6Mtr (Manual Release) 4.0T', qty: 750 },
  { id: 2, partNo: 'EXACT LINER PLUS', details: 'Wheel Alignment With 2 HI-Q Cameras, 4 Pcs of Bracket on Rim', qty: 150 },
  { id: 3, partNo: 'AEF-EPQ-4C', details: 'Wheel Alignment With 4 HI-Q New Generation Tele Cameras, 4 Pcs of Clamps on Tires', qty: 1000 },
  { id: 4, partNo: 'EM9280', details: 'Wheel Balancer With Monitor, Rim Diameter 1"-35"', qty: 240 },
  { id: 5, partNo: 'EM9380', details: 'Wheel Balancer With Monitor, Rim Diameter 1"-35"', qty: 500 },
];

export default function RequestQuoteDialog(props: any) {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();
  const [firstName, setFirstName] = React.useState<string>(initialUser.firstName);
  const [adminFirstNameError, setAdminFirstNameError] = React.useState<boolean>(false);
  const [lastName, setLastName] = React.useState<string>(initialUser.lastName);
  const [adminLastNameError, setAdminLastNameError] = React.useState<boolean>(false);
  const [mobile, setMobile] = React.useState<string>(initialUser.mobile);
  const [adminMobileError, setAdminMobileError] = React.useState<boolean>(false);
  const [email, setEmail] = React.useState<string>(initialUser.email);
  const [adminEmailError, setAdminEmailError] = React.useState<boolean>(false);
  const [cartItems, setCartItems] = React.useState<any[]>(initialCart);
  const [errorMessage, showErrorMessage] = React.useState<any>(null);
  const [successMessage, setSuccessMessage] = React.useState<any>(null);
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [deleteItemId, setDeleteItemId] = React.useState<any>(null);
  const [catName, setCatName] = React.useState<any>(null);
  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  let sapCustomerId: any = _.get(profileDetails, "data.data.basicInfo.sapCustomerId", "");
  const { setOpenDialog } = props;
  const b2bUserId = get(profileDetails, 'data.data.basicInfo.b2bUserId', "");
  const emailId = get(profileDetails, 'data.data.basicInfo.email', "");
  const userType: any = (profileDetails && profileDetails.data && profileDetails.data.data && profileDetails.data.data.basicInfo && profileDetails.data.data.basicInfo?.userType) || "";
  const mobileNo = get(profileDetails, 'data.data.basicInfo.phoneNumber', "");
  const firstTelNo = get(profileDetails, 'data.data.basicInfo.firstTelephoneNumber', "");
  const adminId = get(profileDetails, 'data.data.basicInfo.adminId', "");

  const assignKamArray = get(profileDetails, 'data.data.basicInfo.assignedKamAndFse', []);
  const assignKam = [...new Set(assignKamArray.map((item: any) => item.assignKam))].join(',');

  const selectedBrand = get(profileDetails, 'data.data.customerInfo.selectedBrand', []);
  const brandsToUse = selectedBrand && selectedBrand.length
    ? selectedBrand
    : get(profileDetails, 'data.data.customerInfo.organizationIds', []);
  const fseIdArray = [...new Set(brandsToUse.map((item: any) => String(item.fseId)))];

  const [stockItems, setStockItems] = React.useState<any>([]);
  const webApplicationLoginId = sessionStorage.getItem('webApplicationLoginId');
  const [loading, setLoading] = React.useState<boolean>(false);
  const b2cUserId = get(profileDetails, "data.data.basicInfo.b2cUserId", "");
  const customerTierType = sessionStorage.getItem('userType') === 'FSE' ? sessionStorage.getItem('customerTierType') ? sessionStorage.getItem('customerTierType') : get(profileDetails, 'data.data.customerInfo.customerTierType', '') : get(profileDetails, 'data.data.customerInfo.customerTierType', '');
  const history = useHistory();
  let quotationNo: any;
  let status: any;
  const [page, setPage] = React.useState(0);
  const [invalidEmail, setInvalidEmail] = React.useState<boolean>(false);

  useEffect(() => {
    if (props.itemsWithStock && Array.isArray(props.itemsWithStock)) {
      // Initialize stockItems with qty property if it doesn't exist
      const itemsWithQty = props.itemsWithStock.map((item: any) => ({
        ...item,
        qty: item.qty || 1 // Default to 1 if qty doesn't exist
      }));
      setStockItems(itemsWithQty);
    }
  }, [props.itemsWithStock]);


  const handleopenCloseErrorSnackbar = (open?: any) => {
    setOpenErrorSnackbar(open ? true : false);
  };

  const handleopenCloseSnackbar = (open?: any) => {
    setOpenSnackbar(open ? true : false);
  };

  const populateProfileData = useCallback(() => {
    const profile = get(profileDetails, 'data.data', {});
    profile && profile.basicInfo && profile.basicInfo.firstName ? setFirstName(profile.basicInfo.firstName) : setFirstName("");
    profile && profile.basicInfo && profile.basicInfo.lastName ? setLastName(profile.basicInfo.lastName) : setLastName("");
    profile && profile.basicInfo && profile.basicInfo.phoneNumber ?
      setMobile(profile.basicInfo.phoneNumber) :
      profile && profile.basicInfo && profile.basicInfo.firstTelephoneNumber ?
        setMobile(profile.basicInfo.firstTelephoneNumber)
        : setMobile("");
    profile && profile.basicInfo && profile.basicInfo.email ? setEmail(profile.basicInfo.email) : setEmail("");
  }, [profileDetails])

  useEffect(() => {
    const b2cUid = sessionStorage.getItem('userId');
    // dispatch(getProfile(b2cUid, "dealerUser"));
    populateProfileData();
  }, []); // eslint-disable-line

  const requestQuoteOnClickOfSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    setLoading(true);
    const products = stockItems.map((item: any) => ({
      "partNo": item.partNo || item.id?.toString() || "",
      "sapPartNo": item.sap || item.sapPartNo || "",
      "partDetails": item.description || item.details || "",
      "requestedQty": item.qty?.toString() || "1",
      "partImages": item.partImages || item.images || [],
      "availability": item.availability || "",
      "warranty": item.warranty || ""
    }));

    let payload = {
      "firstName": firstName,
      "lastName": lastName,
      "sapCustomerId": sapCustomerId,
      "b2bUserId": b2bUserId,
      "userRole": userType,
      "b2cUserId": b2cUserId,
      "customerType": customerTierType,
      "customerName": sessionStorage.getItem('userType') === 'FSE'
        ? sessionStorage.getItem("CompanyName")
        : sessionStorage.getItem('customerName'),
      "emailId": email,
      "mobileNo": mobile || mobileNo || firstTelNo || "",
      "subUserAdmin": userType == 'Admin' ? b2bUserId : adminId,
      "assignKam": assignKam,
      "assignedFSEs": fseIdArray,
      "webApplicationLoginId": webApplicationLoginId,
      "products": products
    };

    let responseData: any = await dispatch(postRequestQuote(payload));

    if (responseData && responseData.status === 400 || responseData && responseData.success === false) {
      handleopenCloseErrorSnackbar(true);
      let errorMessage = "";

      if (responseData?.error?.messageText) {
        errorMessage = responseData.error.messageText;
      } else if (typeof responseData?.error === "string") {
        errorMessage = responseData.error;
      } else if (responseData?.message?.message) {
        errorMessage = responseData.message.message;
      } else if (typeof responseData?.message === "string") {
        errorMessage = responseData.message;
      }
      showErrorMessage(errorMessage);
      setLoading(false);
    } else {
      setSuccessMessage("Quote request submitted successfully!");
      handleopenCloseSnackbar(true);
      setLoading(false);

      // 1️⃣ Close the popup after 1s
      setTimeout(() => {
        setOpenDialog(false);
        // 2️⃣ Then reset items after popup has closed (say after 300ms more)

        // setTimeout(() => {
        //   const updatedItems = props.items.map((item: any) => ({
        //     ...item,
        //     qty: 0,
        //   }));
        //   props.setItems(updatedItems);
        // }, 300);

      }, 1000);
    };
  }

  const handleInputChange = (e: any, setterName: any, errorSetterName?: any, type?: string) => {
    let value = e.target.value;

    if (type === "mobileNo") {
      value = value.replace(/[^0-9+\s-]/g, '');
    } else if (type === "firstName" || type === "lastName") {
      value = value.replace(/[^a-zA-Z0-9 ]/g, '');
      if (value.length > 250) return;
    }

    setterName(value);

    if (errorSetterName && e.target.required) {
      if (value === "" || value.trim() === "") {
        errorSetterName(true);
      } else {
        errorSetterName(false);
      }
    }
    
    // Handle email validation on change
    if (type === "email" || setterName === setEmail) {
      if (value.trim() === "") {
        setInvalidEmail(false);
        setAdminEmailError(false);
      } else {
        const isValid = validateEmail(value);
        setInvalidEmail(!isValid);
        setAdminEmailError(!isValid);
      }
    }
  };

  const validateEmail = (email: string) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const validateMobile = (number: string) => {
    const cleanNumber = number.replace(/[^0-9]/g, '');
    const re = sessionStorage.getItem('customerOnboardingType') === "Int. Business" ? /^\d{5,30}$/ : /^\d{10}$/;
    return re.test(cleanNumber);
  };

  const validateFormFields = (action: string, value: any) => {
    switch (action) {
      case "firstName":
      case "lastName": {
        const re = /^[a-zA-Z0-9 ]{1,250}$/;
        return re.test(value);
      }
      default:
        return true;
    }
  };

  const validateForm = () => {
    let isValid = true;

    // Reset all errors
    setAdminFirstNameError(false);
    setAdminLastNameError(false);
    setAdminMobileError(false);
    setAdminEmailError(false);
    setInvalidEmail(false);

    if (firstName.trim() === "") {
      setAdminFirstNameError(true);
      isValid = false;
    } else if (!validateFormFields("firstName", firstName)) {
      setAdminFirstNameError(true);
      isValid = false;
    }

    if (lastName.trim() === "") {
      setAdminLastNameError(true);
      isValid = false;
    } else if (!validateFormFields("lastName", lastName)) {
      setAdminLastNameError(true);
      isValid = false;
    }

    if (mobile.trim() === "") {
      setAdminMobileError(true);
      isValid = false;
    } else {
      setAdminMobileError(false);
    }

    if (email.trim() === "") {
      setAdminEmailError(true);
      isValid = false;
    } else if (!validateEmail(email)) {
      setAdminEmailError(true);
      setInvalidEmail(true);
      isValid = false;
    }

    if (stockItems.length === 0) {
      isValid = false;
    }

    if (!isValid) {
      showErrorMessage("Please fill all mandatory fields.");
      handleopenCloseErrorSnackbar(true);
    }

    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      setSuccessMessage("Quote request submitted successfully!");
      handleopenCloseSnackbar(true);
      // Add your submit logic here
    }
  };

  const handleDeleteItem = (id: any) => {
    setDeleteItemId(id.id);
    setCatName(id.catName)
    setOpenDeleteDialog(true);
  };

  const handleQtyChange = (id: any, operation: 'increment' | 'decrement') => {
    setStockItems((prevItems: any) =>
      prevItems.map((item: any) => {
        if (item.id === id) {
          let newQty = parseInt(item.qty) || 1;
          if (operation === 'increment' && newQty < 999) {
            newQty += 1;
          } else if (operation === 'decrement' && newQty > 1) {
            newQty -= 1;
          }
          return { ...item, qty: newQty };
        }
        return item;
      })
    );
  };

  const confirmDelete = () => {
    if (!deleteItemId || !catName) return;

    const deleteIdStr = String(deleteItemId);
    const targetCategory = catName.trim().toLowerCase();
    // 1️⃣ Update categorizedItems → only modify that category
    const updatedCategorized = Object.entries(props.categorizedItems || {}).reduce(
      (acc: Record<string, any[]>, [category, categoryItems]) => {
        if (!Array.isArray(categoryItems)) {
          acc[category] = [];
          return acc;
        }

        const normalizedCategory = category.trim().toLowerCase();

        // Only set qty=0 in the category we are deleting from
        acc[category] = categoryItems.map((item: any) =>
          String(item.id) === deleteIdStr &&
            item.catName?.trim()?.toLowerCase() === targetCategory
            ? { ...item, qty: 0 }
            : item
        );

        return acc;
      },
      {}
    );

    props.setCategorizedItems(updatedCategorized);
    // 3️⃣ Update itemsWithStock → remove only if that category item is deleted
    props.setItemsWithStock((prev: any) =>
      prev.filter(
        (item: any) =>
          !(
            String(item.id) === deleteIdStr &&
            item.catName?.trim()?.toLowerCase() === targetCategory
          )
      )
    );

    // 4️⃣ Update local stockItems → remove from dialog
    setStockItems((prev: any) =>
      prev.filter(
        (item: any) =>
          !(
            String(item.id) === deleteIdStr &&
            item.catName?.trim()?.toLowerCase() === targetCategory
          )
      )
    );

    // 5️⃣ UI cleanup
    setOpenDeleteDialog(false);
    setDeleteItemId(null);
    setCatName("");
    setSuccessMessage("Item removed from cart");
    handleopenCloseSnackbar(true);
  };



  return (
    <Fragment>
      {loading && <FullscreenLoader />}
      <div className={classes.root}>
        <Snackbar
          open={openSnackbar}
          handleopenClose={() => handleopenCloseSnackbar(false)}
          message={successMessage}
        />
        <Snackbar
          open={openErrorSnackbar}
          type="error"
          handleopenClose={() => handleopenCloseErrorSnackbar(false)}
          message={errorMessage}
        />

        {/* Dialog Header */}
        <Toolbar
          className={clsx(classes.root)}>
          <div className="col-12 mb-2 mt-2">
            <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
              <h4 className="shift-to-party-page-title">
                <div className={classes.addUpdateDailogTitle}>
                  Request Quote
                </div>
                <IconButton aria-label="close" className="float-right" onClick={() => { setOpenDialog(); }}>
                  <CloseIcon />
                </IconButton>
              </h4>
            </Typography>
          </div>
        </Toolbar>

        {/* Form Section */}
        <div className={classes.formContainer}>
          <div className={classes.inputRow}>
            <TextField
              required
              id="firstName"
              value={firstName}
              error={adminFirstNameError}
              onChange={(e: any) => handleInputChange(e, setFirstName, setAdminFirstNameError, "firstName")}
              size="small"
              className={classes.textField}
              label="First Name"
              variant="outlined"
              placeholder="First Name"
              inputProps={{ maxLength: 250 }}
            />
            <TextField
              required
              id="lastName"
              value={lastName}
              error={adminLastNameError}
              onChange={(e: any) => handleInputChange(e, setLastName, setAdminLastNameError, "lastName")}
              size="small"
              className={classes.textField}
              label="Last Name"
              variant="outlined"
              placeholder="Last Name"
              inputProps={{ maxLength: 250 }}
            />
          </div>
          <div className={classes.inputRow}>
            <TextField
              required
              id="mobile"
              value={mobile}
              error={adminMobileError}
              onChange={(e: any) => handleInputChange(e, setMobile, setAdminMobileError, "mobileNo")}
              size="small"
              className={classes.textField}
              label="Mobile"
              variant="outlined"
              placeholder="Mobile No."
            />
            <TextField
              required
              id="email"
              value={email}
              helperText={invalidEmail ? "Please enter a valid email address." : ""}
              error={adminEmailError}
              onChange={(e: any) => handleInputChange(e, setEmail, setAdminEmailError, "email")}
              size="small"
              className={classes.textField}
              label="Email"
              variant="outlined"
              placeholder="Email ID"
            />
          </div>
        </div>

        {/* Cart Section */}
        <div className={classes.cartSection}>
          <Typography className={classes.cartTitle}>
            Your Cart
          </Typography>
          {stockItems.length === 0 && !successMessage?.includes('Quote request') ? (
            <div style={{
              padding: '40px 20px',
              textAlign: 'center',
              border: '1px solid #E8E8E8',
              borderRadius: '4px',
              backgroundColor: '#F8F8F8'
            }}>
              <Typography style={{
                fontFamily: 'Nunito',
                fontSize: '1rem',
                color: '#666666',
                fontWeight: 500
              }}>
                Your cart is empty. Please add items to request a quote.
              </Typography>
            </div>
          ) : (
            <div className={classes.tableWrapper}>
              <Table className={classes.table}>
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell>Sr No.</TableCell>
                    <TableCell>AutoEquip Part No.</TableCell>
                    <TableCell>Equipment Details</TableCell>
                    <TableCell align="center">Qty</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stockItems.map((item: any, index: any) => (
                    <TableRow key={item.id}>
                      <TableCell className={classes.tableCell}>{index + 1}</TableCell>
                      <TableCell className={classes.tableCell}>{item.sap}</TableCell>
                      <TableCell className={classes.tableCell}>{item.description}</TableCell>
                      <TableCell align="center">
                        <div className={classes.qtyContainer}>
                          <IconButton
                            className={classes.qtyButton}
                            onClick={() => handleQtyChange(item.id, 'decrement')}
                            disabled={item.qty <= 1}
                          >
                            <RemoveIcon />
                          </IconButton>
                          <span className={classes.qtyText}>{item.qty}</span>
                          <IconButton
                            className={classes.qtyButton}
                            onClick={() => handleQtyChange(item.id, 'increment')}
                            disabled={item.qty >= 999}
                          >
                            <AddIcon />
                          </IconButton>
                        </div>
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          className={classes.deleteButton}
                          onClick={() => handleDeleteItem(item)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </div>

        {/* Dialog Footer */}
        <div className={classes.dialogFooter}>
          <Button
            variant="contained"
            className={classes.submitButton}
            onClick={requestQuoteOnClickOfSubmit}
          >
            Submit
          </Button>
          <Button
            variant="contained"
            className={classes.cancelButton}
            onClick={() => setOpenDialog()}
          >
            Cancel
          </Button>
        </div>

        <DeleteDialog
          open={openDeleteDialog}
          text="Are you sure you want to delete this part from cart ?"
          handleopenClose={(data: any) => {
            if (data === 'delete') {
              confirmDelete();
            } else {
              setOpenDeleteDialog(false);
            }
          }}
        />
      </div>
    </Fragment>
  );
}